import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { wikiActions } from "../../../redux/wiki";

const ExemploRedux = () => {
  const { pessoa } = useSelector((state) => state.wiki);
  const dispatch = useDispatch();

  const inputChangeHandler = (e) => {
    dispatch(
      wikiActions.salvarEstado({
        ...pessoa,
        [e.target.name]: e.target.type === "checkbox" ? e.target.checked : e.target.value,
      }),
    );
  };

  return (
    <div style={{ backgroundColor: "white", padding: "20px" }}>
      <h1>Exemplo Redux + Redux Toolkit</h1>
      <a href="https://redux-toolkit.js.org/" target="_blank" rel="noreferrer">
        Redux Toolkit
      </a>
      <br />
      <a
        href="https://chrome.google.com/webstore/detail/redux-devtools/lmhkpmbekcpmknklioeibfkpmmfibljd"
        target="_blank"
        rel="noreferrer"
      >
        Redux DevTools
      </a>
      : Essa extensão auxilia na inspeção dos estados no Redux
      <br />
      <a href="https://immerjs.github.io/immer/" target="_blank" rel="noreferrer">
        Immer
      </a>
      : É importante entender o Immer porque ele é a ferramenta utilizada pelo Redux Toolkit na comparação profunda de
      estado de objetos Javascript
      <br />
      <br />
      <h4>Estado</h4>
      <p>
        Nome:
        <br /> <input type="text" name="nome" value={pessoa.nome} onChange={inputChangeHandler} />
      </p>
      <p>
        E-mail:
        <br /> <input type="text" name="email" value={pessoa.email} onChange={inputChangeHandler} />
      </p>
      <p>
        Ativo:
        <br /> <input type="checkbox" name="ativo" checked={pessoa.ativo} onChange={inputChangeHandler} />
      </p>
    </div>
  );
};

export default ExemploRedux;
